var map = {
	"./homepage.de-CH.json": 1390,
	"./homepage.de-DE.json": 1391,
	"./homepage.en-CA.json": 1392,
	"./homepage.en-GB.json": 1393,
	"./homepage.en-IN.json": 1394,
	"./homepage.en-ME.json": 1395,
	"./homepage.en-US.json": 1396,
	"./homepage.es-EM.json": 1397,
	"./homepage.es-ES.json": 1398,
	"./homepage.fr-BE.json": 1399,
	"./homepage.fr-CA.json": 1400,
	"./homepage.fr-CH.json": 1401,
	"./homepage.nl-BE.json": 1402,
	"./homepage.nl-NL.json": 1403,
	"./homepage.pl-PL.json": 1404,
	"./homepage.pt-BR.json": 1405
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1389;